module.exports = __webpack_public_path__ + "img/root.470700a8.png";